import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../util/utils';

import {MotifNavigationIcMoreVert24px} from '@ey-xd/motif-icon';
import OutputText from '@ey/canvascoreservices/OutputText';

import Button from '../../../CoreWrappers/Button';
import Dropdown from '../../../CoreWrappers/Dropdown';
import Checkbox from '../../../CoreWrappers/Checkbox';
import StyledColumnVisibilityDropdown from './StyledColumnVisibilityDropdown';

const ColumnVisibilityDropdown = ({
	options = null,
	value = [],
	onChange = null,
	maxValues = 4,
	headerLabel = '',
	...rest
}) => {
	const renderTrigger = () => {
		const props = {
			svg: MotifNavigationIcMoreVert24px,
			variant: 'text-alt',
			label: labels.customizableTable
		};

		return <Button {...props} />;
	};

	const renderItem = ({id, label}) => {
		const checked = value.includes(id);
		const maxedOut = value.length >= maxValues;
		const disabled = maxedOut && !checked;

		const props = {
			id: `${id}_checkbox`,
			checked,
			value: checked,
			label,
			disabled,
			onChange: () => {
				let newValue = [...value];
				if (checked) newValue = newValue.filter((itemId) => itemId !== id);
				else if (!maxedOut) newValue = [...value, id];
				onChange && onChange(newValue);
			}
		};

		return <Checkbox {...props} />;
	};

	const items = options.map((item) => {
		if (item.isHeader)
			return {
				...item,
				type: 'container'
			};

		return {
			...item,
			customRender: renderItem,
			type: 'container'
		};
	});

	const props = {
		placement: 'bottom-right',
		trigger: renderTrigger(),
		items,
		topfix: true,
		maxItems: 6,
		itemSize: 40,
		header: () => (
			<OutputText body2 ellipsis>
				{headerLabel}
			</OutputText>
		)
	};

	return (
		<StyledColumnVisibilityDropdown {...rest}>
			<Dropdown {...props} />
		</StyledColumnVisibilityDropdown>
	);
};

export const columnVisibilityOptionsPropTypes = PropTypes.arrayOf(
	PropTypes.shape({
		id: PropTypes.string,
		label: PropTypes.string
	})
);

ColumnVisibilityDropdown.propTypes = {
	options: columnVisibilityOptionsPropTypes,
	value: PropTypes.arrayOf(PropTypes.string),
	onChange: PropTypes.func,
	maxValues: PropTypes.number,
	headerLabel: PropTypes.string
};

export default ColumnVisibilityDropdown;
